import React from 'react';
const LogoPrideDesktop = () => {
  return (
    <svg id="LogoPrideDesktop" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 1200 350">
      <title id="zillowLogo">Zillow Pride Logo</title>
      <path
        className="st0"
        d="M784.9,87.2h36l10.4,34.1c3.5,11.3,6.5,21.9,9.3,32.6h0.4c3-10.5,6-21.7,9.5-32.6l10.9-34.1h26.6l10.7,34.1
	c3.6,11.7,6.3,21.8,9.3,32.6h0.4c2.8-10.8,5.9-21.2,9.3-32.6l10.4-34.1h33.4l-36.2,112.6h-32.9l-9-28.3c-3.5-11.1-6.7-22.4-9.5-32.8
	h-0.4c-2.8,10.4-6.1,21.3-9.7,32.6l-9.1,28.5h-33.5L784.9,87.2z"
      />
      <rect x="542.9" y="27.7" className="st0" width="36.4" height="172.1" />
      <rect x="606.2" y="27.7" className="st0" width="36.4" height="172.1" />
      <path
        className="st0"
        d="M660.6,143.9c0-34.2,27.6-59.6,61.3-59.6c33.4,0,61,25.3,61,59.6s-27.6,59.7-61,59.7
	C688.2,203.6,660.6,178.2,660.6,143.9 M748.1,143.9c0-16.8-12-28.2-26.1-28.2c-14.5,0-26.4,11.4-26.4,28.2s12,28.2,26.4,28.2
	C736.1,172.1,748.1,160.8,748.1,143.9"
      />
      <polygon
        className="st0"
        points="332.4,43.7 332.4,76.8 396.7,76.8 396.9,77.3 330.4,190.3 330.4,199.8 455.7,199.8 455.7,166.7
	386.1,166.7 385.9,166.2 452.3,53.3 452.3,53.3 452.3,43.7 "
      />
      <path
        className="st0"
        d="M497.1,30.8c11.3,0.2,20.3,9.4,20.2,20.7s-9.4,20.3-20.7,20.2c-11.2-0.2-20.2-9.3-20.2-20.4
	C476.5,39.9,485.7,30.8,497.1,30.8 M478.9,87.2h36.4v112.6h-36.4V87.2z"
      />
      <path
        className="st1"
        d="M985.6,71.2c0.2-2.9-2.1-5.4-5-5.5c-0.1,0-0.3,0-0.4,0h-5.8v15.7h2.6v-4.7h2.5l2.9,4.7h2.9l-3.1-5.1
	C984.4,75.5,985.7,73.4,985.6,71.2z M980.1,74.4h-3V68h3c1.8,0.1,3.1,1.6,3,3.4C983,73,981.7,74.3,980.1,74.4L980.1,74.4z"
      />
      <path
        className="st1"
        d="M979.4,60.2c-7.5,0-13.6,6.1-13.6,13.6c0,7.5,6.1,13.6,13.6,13.6c7.5,0,13.6-6.1,13.6-13.6c0,0,0,0,0,0l0,0
	C993,66.3,986.9,60.2,979.4,60.2z M979.4,84.8c-6.1,0-11-4.9-11-11s4.9-11,11-11s11,4.9,11,11l0,0C990.4,79.8,985.5,84.8,979.4,84.8
	z"
      />
      <path
        className="st1"
        d="M1125.8,292.9h-46.2c0.3,11.5,7.4,18.3,18.8,18.3c7.9,0,13.3-3.1,15.8-8.8h11.3c-2.1,11-13.1,18.6-27.1,18.6
	c-18.4,0-29.9-12.2-29.9-31.5c0-18.9,11.7-31.3,29.4-31.3c16.8,0,28.2,11.6,28.2,28.1C1126.1,288.5,1126,290.7,1125.8,292.9z
	 M1115.1,284.2c0-10.5-6.5-17-17.3-17s-17.6,6.9-18.1,17H1115.1z"
      />
      <path
        className="st1"
        d="M863.4,259h11.3v11c3.2-7.6,10.5-12.6,20.9-12.6c14.7,0,22.2,8.6,22.2,24.5v36.8h-11.2v-31.9
	c0-13.4-4.4-19.7-15-19.7c-11.2,0-16.9,7.9-16.9,20v31.6h-11.3V259z"
      />
      <path
        className="st1"
        d="M787.5,289c0-17.7,11.3-31.6,29.9-31.6c9.5,0,17.3,4.8,21.1,12.2V259h11.2v60h-11.2v-10.6
	c-3.8,7.4-12.4,12.1-21.3,12.1C798,320.5,787.5,306.7,787.5,289z M839,289c0-11.6-7.2-21.5-20.3-21.5c-12.3,0-20,9.1-20,21.5
	s7.7,21.3,20,21.3C831.8,310.4,839,300.6,839,289L839,289z"
      />
      <path
        className="st1"
        d="M926.1,289c0-17.7,11.3-31.6,29.9-31.6c9.5,0,17.3,4.8,21.1,12.2V259h11.2v60H977v-10.6
	c-3.8,7.4-12.4,12.1-21.3,12.1C936.6,320.5,926.1,306.7,926.1,289z M977.6,289c0-11.6-7.2-21.5-20.3-21.5c-12.4,0-20,9.1-20,21.5
	s7.7,21.3,20,21.3C970.4,310.4,977.6,300.6,977.6,289z"
      />
      <path
        className="st1"
        d="M691.3,235.8h12.3l29.8,66.4l29.9-66.4h12.2v83h-11.2V260L738,318.7h-9l-26.5-59.1v59.1h-11.2V235.8z"
      />
      <path
        className="st1"
        d="M1059.2,259v58.8c0,11.5-3.7,20.1-10.5,25.4c-5.1,3.8-12.2,5.6-20.8,5.6c-8.2,0-16-2-21.5-5.9
	c-5.3-3.6-8.6-9.6-8.9-16h11.9c0.8,7.1,6.8,12.3,18.3,12.3c13.1,0,20.2-6.3,20.2-20.7v-9.8c-3.8,7.6-12.7,12.2-21.5,12.2
	c-18.5,0-29.8-13.9-29.8-31.7s12.2-31.8,30.1-31.8c9.3,0,17.4,4.6,21.2,12.3V259H1059.2z M1048.4,289.2c0-11.9-7.7-21.6-20.4-21.6
	c-12,0-20.2,9.2-20.2,21.6s8.2,21.5,20.2,21.5C1040.7,310.7,1048.4,301,1048.4,289.2z"
      />
      <path
        className="st1"
        d="M1137.9,258.9h11.4v13.2c2.4-10.2,10.1-14.7,17.7-14.7c1.8,0,3.7,0.1,5.5,0.5v10.5c-1.9-0.3-3.8-0.5-5.6-0.4
	c-11.9,0-17.6,10.9-17.6,24.4v26.3h-11.4L1137.9,258.9z"
      />
      <path
        className="st1"
        d="M454.8,292.9h-46.2c0.3,11.5,7.4,18.3,18.8,18.3c7.9,0,13.3-3.1,15.8-8.8h11.3c-2.1,11-13.1,18.6-27.1,18.6
	c-18.4,0-29.9-12.2-29.9-31.5c0-18.9,11.6-31.3,29.4-31.3c16.8,0,28.2,11.6,28.2,28.1C455.1,288.5,455,290.7,454.8,292.9z
	 M444.1,284.2c0-10.5-6.5-17-17.4-17s-17.6,6.9-18.1,17H444.1z"
      />
      <path
        className="st1"
        d="M465.6,259h11.3v11c3.2-7.6,10.5-12.6,20.9-12.6c14.7,0,22.2,8.6,22.2,24.5v36.8h-11.1v-31.9
	c0-13.4-4.4-19.7-15-19.7c-11.1,0-16.9,7.9-16.9,20v31.6h-11.3V259z"
      />
      <path
        className="st1"
        d="M564.4,308.5v10c-3.3,0.6-6.7,0.9-10.1,0.9c-7,0-18.3-1.3-18.3-20.6v-30.5h-10.8v-9.5h10.8V240h11.3v18.9h15
	v9.5h-15v28c0,11.4,3.9,13,9.6,13C559.4,309.3,561.9,309,564.4,308.5z"
      />
      <path
        className="st1"
        d="M570.4,289c0-17.7,11.3-31.6,29.9-31.6c9.5,0,17.3,4.8,21.1,12.2V259h11.2v60h-11.2v-10.6
	c-3.8,7.4-12.3,12.1-21.3,12.1C580.9,320.5,570.4,306.7,570.4,289z M621.9,289c0-11.6-7.2-21.5-20.3-21.5c-12.3,0-20,9.1-20,21.5
	s7.7,21.3,20,21.3C614.8,310.4,621.9,300.6,621.9,289z"
      />
      <path className="st1" d="M646.3,235.8h11.3v83.1h-11.3V235.8z" />
      <path
        className="st1"
        d="M374.4,290.6c11-3.8,18.6-13.8,18.6-26.6c0-16.5-12.5-28.3-28.5-28.3h-33.4V319h11.7v-26.6h19l16.6,26.6h13.5
	l-17.5-28.3L374.4,290.6z M342.8,246.3h20.1c10.1,0,18.4,6.8,18.4,17.7s-8.4,17.6-18.4,17.6h-20.2L342.8,246.3z"
      />
      <g>
        <path className="st2" d="M288.4,162.4v-46.6l-34.5-27.3v81.7C267.2,166.8,279.2,164.1,288.4,162.4z" />
        <path
          className="st1"
          d="M217.2,111.5c2.6,3.1,4.8,5.8,6,7.3c0.6,0.7,0.5,1.8-0.2,2.4c-0.1,0.1-0.1,0.1-0.2,0.1
		c-1.8,1.4-3.7,2.9-5.6,4.4v54.4c12.6-3.7,25.1-7.1,36.6-10V88.5l-36.6-28.9V111.5z"
        />
        <path className="st3" d="M180.6,191.5c11.7-3.9,24.2-7.6,36.6-11.2v-54.4c-12.2,9.8-24.7,21-36.6,32.3V191.5z" />
        <path
          className="st3"
          d="M195,87.3c1.4-0.4,2.1,0.2,3,1.1c3.6,4,12.7,15.1,19.3,23.1v-52l-36.6-28.9v60.7
		C185.8,89.7,190.6,88.4,195,87.3z"
        />
        <path className="st4" d="M144,196.4v7.9c10.2-4,22.9-8.4,36.6-12.8v-33.3C167,171.1,154.3,184.5,144,196.4z" />
        <path className="st4" d="M180.6,91.3V30.6L144.3,1.9L144,2.2v101.2C157.4,98.6,169.8,94.5,180.6,91.3z" />
        <path
          className="st5"
          d="M134.9,207.5c-0.4,0.5-0.1,0.6,0.2,0.5c2.7-1.2,5.8-2.4,9-3.7v-7.9C140.7,200.2,137.6,204,134.9,207.5z"
        />
        <path className="st5" d="M144,103.4V2.2l-36.6,28.9v86.1C119.9,112.2,132.3,107.6,144,103.4z" />
        <path className="st6" d="M107.4,117.2V31L70.8,59.9v72.3C82.8,127.1,95.2,122,107.4,117.2z" />
        <path className="st7" d="M70.8,59.9L34.2,88.8v60c11.3-5.4,23.7-11,36.6-16.6V59.9z" />
        <path className="black" d="M0,115.8v51c9.2-5.5,21-11.6,34.2-17.9v-60L0,115.8z" />
        <path className="st2" d="M288.4,318.6V213.9c-8.4,1.4-20.4,4.2-34.5,7.8v96.9H288.4z" />
        <path className="st1" d="M217.2,318.6h36.6v-96.9c-11.1,2.9-23.5,6.3-36.6,10.2V318.6z" />
        <path className="st3" d="M180.6,243.2v75.5h36.6v-86.8C205.4,235.3,193.1,239.1,180.6,243.2z" />
        <path className="st4" d="M144,255.6v63h36.6v-75.4C168.3,247.2,156,251.3,144,255.6z" />
        <path className="st5" d="M107.4,269.6v49H144v-63C131.1,260.2,118.7,265,107.4,269.6z" />
        <path
          className="st5"
          d="M138.1,149.9c0.5-0.3,0.3-0.7-0.2-0.5c-7.3,2.4-18,6.5-30.5,11.5v16.5C118.5,166.3,129.2,156.6,138.1,149.9z"
        />
        <path className="st6" d="M107.4,160.9c-11.2,4.5-23.9,9.8-36.6,15.3v41.6c11.3-13.7,24.2-27.9,36.6-40.5V160.9z" />
        <path
          className="st6"
          d="M77.8,283.1c-1,0.7-2.4,0.5-3.1-0.5l-3.9-4.6v40.5h36.6v-49C96.4,274.2,86.3,278.8,77.8,283.1z"
        />
        <path
          className="st7"
          d="M47.8,250.6c-0.7-0.9-0.8-1.3,0.1-2.7c6.1-8.9,14-19.3,22.9-30.1v-41.6c-12.5,5.4-25.1,11.1-36.6,16.4v126
		h36.6v-40.5L47.8,250.6z"
        />
        <path className="black" d="M0,209.8v108.8h34.2v-126C20.4,199.1,8.3,205.1,0,209.8z" />
      </g>
    </svg>
  );
};

export default LogoPrideDesktop;
